export default __webpack_public_path__ + "static/media/ACUTE-PAIN.fa6c7541.png";